<template>
  <div>
    <form action="/">
      <van-sticky>
        <van-search v-model="searchText" show-action placeholder="搜索学生姓名" @search="onSearch" @cancel="onCancel"
          action-text="重置" />
      </van-sticky>

    </form>
    <van-tabs type="card" style="margin-top: 10px" color="#1989fa" v-model="activeName" @click="handleTabsClick">
      <van-tab title="待分配" name="0">
        <van-cell-group inset style="margin-top: 10px;margin-bottom: 10px">
          <van-cell v-for="item in data0" :key="item.fid">
            <template slot="title">{{ item.fcustname }}</template>
            <template slot="label">{{ item.forgname }} {{ item.fgrade }} {{ item.fclasstype }}</template>
            <template slot="right-icon"><van-button size="small" type="info"
              @click="handleGoDetail(item.fid)">分配老师</van-button></template>
          </van-cell>
          <van-empty v-if="data0 && data0.length == 0" description="暂无数据" />
          <!-- <van-cell>
            <template slot="title">程杰</template>
            <template slot="label">福田校区 G6 线下</template>
            <template slot="right-icon"><van-button size="small" type="info" url="/#/detail?id=1">分配老师</van-button></template>
          </van-cell> -->
        </van-cell-group>
      </van-tab>
      <van-tab title="已分配" name="1">
        <van-cell-group inset style="margin-top: 10px;margin-bottom: 10px">
          <van-cell v-for="item in data1" :key="item.fid">
            <template slot="title">{{ item.fcustname }}</template>
            <template slot="label">{{ item.forgname }} {{ item.fgrade }} {{ item.fclasstype }}</template>
            <template slot="right-icon"><van-button size="small" type="info" @click="handleGoDetail(item.fid)"
                >分配老师</van-button></template>
          </van-cell>
          <van-empty v-if="data1 && data1.length == 0" description="暂无数据" />

        </van-cell-group>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
// import { getUserInfo } from '@/libs/utils'
import { selectByPage } from '@/api/public'
// import * as dd from 'dingtalk-jsapi'

import {
  Form,
  Field,
  Calendar,
  Popup,
  Button,
  DatetimePicker,
  Search,
  Toast,
  Tabs,
  Tab,
  CellGroup,
  Cell, Sticky
,Empty } from 'vant';

Vue.use(Sticky);
Vue.use(Form);
Vue.use(Button);
Vue.use(Field);
Vue.use(Calendar);
Vue.use(Popup);
Vue.use(DatetimePicker);
Vue.use(Search);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Empty);
 
export default {
  name: 'index',
  components: {
    // Footer: footer
  },
  computed: {
    getFdate() {
      return moment(this.fdate).format('YYYY-MM-DD')
    }
  },
  created() {
  },
  mounted() {
    this.loadlist()
  },
  methods: {
    handleGoDetail(fid){
      this.$router.push({ name: 'detail', query: { id: fid } })
    },
    handleTabsClick(activeName){
      console.log(activeName)
      this.activeName = activeName
      this.loadlist()
    },
    onCancel() {
      this.searchText = null
      this.loadlist()
    },
    onSearch() {
      this.loadlist()
    },
    loadlist() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      let params = {}
      params.fcustname = this.searchText || ''
      params.ftype = this.activeName
      params.fprojectid = ''
      params.in_pageindex = this.currentpage
      params.in_pagesize = this.pagesize
      params.proc_name = 'sp_secord_cust_sellist_for_phone'
      selectByPage(params).then(res => {
        console.log(res)
        if (this.activeName == '1') {
          this.data1 = res.data.map.list
        }
        if (this.activeName == '0') {
          this.data0 = res.data.map.list
        }
        Toast.clear()
      }).catch(err => {
        console.log(err)
        Toast.clear()
      })
    },
    
  },
  data() {
    return {
      activeName: '0',
      searchText: null,
      currentpage: 1,
      totalsize: 0, // 总条数
      totalpage: 0, // 总页数
      pagesize: 50,
      data0: [],
      data1: [],
    };
  },
}
</script>

<style lang="less" scoped></style>
